<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "kanban",
    },
  },
  methods: {
    loadMoreColumns() {
      this.$emit("loadMoreColumns");
    },
  },
};
</script>

<template>
  <div
    :class="{
      'btn-more-columns': type == 'kanban',
      'btn-more-columns-gantt': type == 'gantt',
    }"
    @click="loadMoreColumns"
  >
    <i class="fas fa-spinner fa-spin" v-if="loading"></i>
    <span v-else> Mostrar más columnas... </span>
  </div>
</template>

<style scoped>
.btn-more-columns {
  display: inline-block;
  max-height: 50px;
  min-width: 200px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: 0.5s ease-in-out;
  position: relative;
  border-radius: 3px;
  cursor: pointer;
  box-shadow: 0 0 4px 2px var(--lego-shadow);
  background-color: var(--lego-bg);
  font-weight: bold;
  letter-spacing: 0.25rem;
  &:hover span {
    text-decoration: underline;
  }
}

.btn-more-columns-gantt {
  text-align: center;
  padding: 0.5rem 0;
  cursor: pointer;
  font-size: 1rem;
  &:hover span {
    text-decoration: underline;
  }
}
</style>
